import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ItemTypeClassesSelectors } from './item-type-classes.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {ItemTypeClass} from '@emm/core/models/item-type-class.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';


export interface ItemTypeClassesQueries extends AsyncActionQueries {
    all$: Observable<ItemTypeClass[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ItemTypeClassesStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, ItemTypeClassesSelectors);
    }

    dispatch = {};

    queries: ItemTypeClassesQueries = {
        all$: this.selectNonNil(ItemTypeClassesSelectors.getValidAll),
        ...this.asyncActionQueries
    };

}
